const baseURL = 'https://api.trios.com.vn/dev/v1';

export { baseURL };
